import { TrackedChangeType } from 'prose-core'
import { TextSelection } from 'prosemirror-state'
import { stepTracker } from '../stepTracker'
import { isInsertion } from '../utils'
import { type TrackedChangesCommandHandler, LiftEmptyBlockCommand } from './types'
import { createTrackedChange, getTrackedChangesFromNode } from './utils'

export const liftEmptyBlock: TrackedChangesCommandHandler = ({ originalTr, wrappedTr, map, state, userId }) => {
  const commandMeta: LiftEmptyBlockCommand | null = originalTr.getMeta('trackedChangeCommand')
  if (!commandMeta) return false
  const {
    meta: { range },
  } = commandMeta

  const liftedNode = originalTr.doc.nodeAt(range.start)
  const deletionPos = range.start - 1
  const deletionTrackedChange = createTrackedChange(TrackedChangeType.Deletion, userId)
  const clone = state.doc.nodeAt(range.start - 1)?.type.createAndFill({ trackedChanges: [deletionTrackedChange] })
  if (liftedNode && !isInsertion(liftedNode) && clone) {
    originalTr.steps.map((step) => wrappedTr.step(step))
    const trackedChanges = getTrackedChangesFromNode(liftedNode, TrackedChangeType.Insertion, userId)
    wrappedTr.setNodeMarkup(range.start, liftedNode.type, { ...liftedNode.attrs, trackedChanges }, liftedNode.marks)
    wrappedTr.insert(deletionPos, clone)
    // wrappedTr.setSelection(originalTr.selection.map(wrappedTr.doc, map))
    // TODO: Fix the caret placement
    wrappedTr.setSelection(TextSelection.create(wrappedTr.doc, wrappedTr.selection.from + 8))
    return true
  }

  stepTracker({ originalTr, wrappedTr, map, state, userId })
  return true
}
